module.exports = __webpack_public_path__ + "img/user.79ae02f8.png";